import $ from 'jquery';

const greeting = name => {
  const element = $('.js-greeting');

  if (element.length) {
    element.text(name);
  }
};
export default greeting;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/brockmeyer-chisel/src/scripts/modules/greeting.js